const SENTINEL_DATE = '01/01/1900';
const INVALID_DATE = 'Invalid Date';

export function formatDate(isoString: unknown): string {
  if (typeof isoString !== 'string' || !isoString) return '';
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return '';
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const yyyy = date.getFullYear();
  const formatted = `${mm}/${dd}/${yyyy}`;
  if (formatted === SENTINEL_DATE) return 'N/A';
  if (formatted === INVALID_DATE) return '';
  return formatted;
}

export function formatCurrency(value: number): string {
  return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

export function formatNumber(value: number, decimals = 1): string {
  return value.toFixed(decimals);
}
